import { Component, OnDestroy, ViewChild, ElementRef, AfterContentInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialogRef } from '@angular/material/dialog';
import { FeatureToggleService } from '../../../../core/services/feature-toggle.service';
import { MPM_PREAUT_VERSION } from '../../../../../configs/toggles.config';
import { GtmService } from '../../../services/gtm.service';
import { GTM_PUSH_CATEGORY_DRAWER, GTM_PUSH_CATEGORY_INTERRACTIONS_PAGES } from '../../../modeles/variables';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import { PersonneState } from '../../../../shared/personne.state';

@Component({
  selector: 'app-faq-modal',
  templateUrl: './faq-modal.component.html',
  styleUrls: ['./faq-modal.component.scss'],
  standalone: false
})
export class FaqModalComponent implements OnDestroy, AfterContentInit {
  @ViewChild('content')
  content: ElementRef;

  isAnimationDisabled = true;
  isFadeVisible = false;

  question1Label = "Quels sont les taux d'intérêts offerts présentement par Desjardins?";
  question2Label = 'À quoi sert la préautorisation?';
  question3Label = 'À quoi m’engage la préautorisation?';
  question4Label = 'Combien de temps est valide ma préautorisation?';
  question5Label = 'D’où peut provenir ma mise de fonds?';
  question6Label = 'Acheter ma première propriété me donne-t-il droit à un crédit d’impôt?';
  question7Label = 'Ai-je droit à une subvention municipale pour acheter ma première propriété?';
  question8Label = 'Ai-je droit à une aide du gouvernement fédéral pour acheter ma première propriété?';

  constructor(
    private readonly _dialogRef: MatDialogRef<FaqModalComponent>,
    private readonly _featureToggleService: FeatureToggleService,
    private readonly _router: Router,
    private readonly _gtm: GtmService,
    private readonly _elementRef: ElementRef
  ) {}

  ngOnDestroy(): void {
    clearAllBodyScrollLocks();
  }

  ngAfterContentInit(): void {
    if (PersonneState.IS_IOS()) {
      disableBodyScroll(this._elementRef.nativeElement);
    } else {
      disableBodyScroll(this.content, { reserveScrollBarGap: true });
    }

    // Pour éviter un saut lorsque la modale ouvre
    // http://github.com/angular/components/issues/11765
    setTimeout(() => {
      this.isFadeVisible = !this.isContentScrolledToBottom;
      this.isAnimationDisabled = false;
    }, 0);
  }

  get isPreautNavEnabled(): boolean {
    return (
      !this._featureToggleService.hasFeatures(MPM_PREAUT_VERSION.Disabled) &&
      !this._router.url.includes('preautorisation')
    );
  }

  goPreaut() {
    this._router.navigateByUrl('/preautorisation-simplifiee');
    this.closeModal();
  }

  closeModal() {
    this._dialogRef.close();
  }

  onScroll() {
    this.isFadeVisible = !this.isContentScrolledToBottom;
  }

  get isContentScrolledToBottom() {
    if (this.content && this.content.nativeElement) {
      return (
        Math.ceil(this.content.nativeElement.offsetHeight + this.content.nativeElement.scrollTop) >=
        this.content.nativeElement.scrollHeight
      );
    }

    return false;
  }

  pushEvent(question: string, action: 'ouverture' | 'fermeture') {
    this._gtm.pushEvent({
      event: GTM_PUSH_CATEGORY_INTERRACTIONS_PAGES,
      category: GTM_PUSH_CATEGORY_DRAWER,
      label: question,
      action: action,
      value: 0,
      nonInteraction: false
    });
  }
}
